var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import { Row } from "../Row";
export var Footer = function (_a) {
    var elements = _a.data.footer.elements, country = _a.country;
    var quantity = elements.length;
    // TO-DO remove this once all countries have the rebranded navigation
    var isRebrandedNavigation = country === "cl";
    return (React.createElement("footer", { className: "bg-gray-100 pt-6 md:pt-16 relative" }, elements.map(function (row, index) { return (React.createElement(Row, __assign({ key: index }, row, { includeSeparator: quantity > 2 ? index === quantity - 2 : index === quantity - 1, isRebrandedNavigation: isRebrandedNavigation }))); })));
};
//# sourceMappingURL=Footer.js.map